import * as React from 'react';
import { UIHeading3 } from '@cian/ui-kit';
import * as styles from './FilterItemMobile.css';

export interface IFilterItemMobileProps {
  title: string;
  marginTop?: number;
  name?: string;
}

export const FilterItemMobile: React.FC<React.PropsWithChildren<IFilterItemMobileProps>> = ({
  children,
  title,
  marginTop = 40,
  name,
}) => {
  return (
    <div style={{ marginTop }} data-name={name}>
      <UIHeading3>{title}</UIHeading3>
      <div className={styles['control']}>{children}</div>
    </div>
  );
};
